import React from 'react';
import { LogoMark } from '@/components/Logo';

export function AuthShell({
  title,
  subtitle,
  children,
}: {
  title: string;
  subtitle?: string;
  children: React.ReactNode;
  minimal?: boolean;
}) {
  return (
    <div className="relative min-h-screen w-full flex items-center justify-center bg-background px-4">
      {/* Subtle background ambient tint */}
      <div className="pointer-events-none absolute -top-40 -left-24 h-[400px] w-[400px] rounded-full bg-primary/5 blur-[120px]" />
      <div className="pointer-events-none absolute -bottom-36 -right-24 h-[400px] w-[400px] rounded-full bg-primary/5 blur-[120px]" />

      <div className="relative z-10 w-full max-w-[400px] rounded-2xl border border-border bg-surface/95 p-7 sm:p-8 shadow-xl backdrop-blur transition-all">
        <header className="mb-6 flex flex-col items-center text-center">
          <div className="mb-3">
            <LogoMark className="h-10 w-10 shrink-0 drop-shadow-sm" />
          </div>
          <h1 className="text-xl font-bold tracking-tight text-foreground sm:text-2xl">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-1 text-xs text-muted-foreground leading-relaxed">
              {subtitle}
            </p>
          )}
        </header>
        {children}
      </div>
    </div>
  );
}
